module.exports = __webpack_public_path__ + "static/media/hi_l.7e374dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/earlySalePopup/hi_l.png
// module id = 1719
// module chunks = 103